import { render, staticRenderFns } from "./centerBox.vue?vue&type=template&id=bb00569e&scoped=true"
import script from "./centerBox.vue?vue&type=script&lang=js"
export * from "./centerBox.vue?vue&type=script&lang=js"
import style0 from "./centerBox.vue?vue&type=style&index=0&id=bb00569e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb00569e",
  null
  
)

export default component.exports